export default "__VITE_ASSET__BAbs0$6L__"